import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './fk-intro.module.css';

import people from '../../public/fitkonnekt/intro/people.png';
import Title from '../../public/fitkonnekt/intro/title.svg';
import AppleStore from '../../public/svg/apple-store.svg';
import OneLineCircle from '../../public/fitkonnekt/intro/one-line-circle.svg';
import { Container } from '../../components';

function FKIntro() {
  return (
    <AnimationOnScroll
      offset={400}
      animateOnce
      duration={2}
      animateIn="animate__fadeIn"
    >
      <section className={styles.intro}>
        <Container>
          <div className={styles.intro_title}>
            <Title />
          </div>
          <div className={styles.intro_inner}>
            <div className={styles.intro_start}>
              <div className={styles.intro_text}>
                FitKonnekt is the live, peer-to-peer, digital fitness training
                mobile app platform, composed of everyday people, fitness
                enthusiasts, and fitness professionals, all training, chatting,
                and connecting together online.
              </div>
              <span className={styles.intro_soon}>Coming Soon</span>
              <AppleStore className={styles.intro_appleStore} />
              <OneLineCircle className={styles.intro_circle} />
            </div>
            <div className={styles.intro_end}>
              <Image
                alt="Fitkonnect intro"
                width={943}
                height={630}
                src={people}
              />
            </div>
          </div>
        </Container>
      </section>
    </AnimationOnScroll>
  );
}

export default FKIntro;
